import type layoutZh from '../zh/layout';

const layout: typeof layoutZh = {
  profile: 'Account center',
  upgrade: 'Purchase / Upgrade',
  buy_plan: 'Purchase/Upgrade',
  buy_entitlement: 'Buy add-on benefits',
  brand_product: 'Creator Outreach',
  support: 'Support',
  user_menu: 'User menu',
  role_admin: 'Admin',
  menu_workbench: 'Workbench',
  menu_store: 'Store authorization',
  menu_talent: 'Creator plaza',
  menu_creator: 'Creator management',
  menu_invitation: 'Invitations',
  menu_dm: 'DMs',
  menu_email: 'Email',
  menu_script: 'Scripts',
  no_shop: 'No store',
  shop_load_failed: 'Failed to load stores'
};

export default layout;
